import { CheckCircleIcon } from "@heroicons/react/24/solid";

interface WelcomeFeatureListProps {
  description: string;
  className?: string;
}

/**
 * Feature list component for the onboarding welcome step.
 * Displays a list of features with check icons.
 */
const WelcomeFeatureList = ({
  description,
  className = "",
}: WelcomeFeatureListProps) => {
  if (!description) return null;

  return (
    <ul
      className={`space-y-2 font-body text-sm font-medium md:text-base ${className}`}
    >
      {description.split("\n").map((line, index) => (
        <li key={index} className="flex items-center gap-2">
          <CheckCircleIcon className="h-5 w-5 text-[#7AD691]" />
          <span>{line}</span>
        </li>
      ))}
    </ul>
  );
};

export default WelcomeFeatureList;
